/* Swipe Again — cookie consent + Google Consent Mode v2. Standalone; does not touch sa.js. */
(function () {
  var KEY = 'sa-consent-choice';
  function setConsent(granted) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(['consent', 'update', {
      ad_storage: granted ? 'granted' : 'denied',
      analytics_storage: granted ? 'granted' : 'denied',
      ad_user_data: granted ? 'granted' : 'denied',
      ad_personalization: granted ? 'granted' : 'denied'
    }]);
    try { localStorage.setItem(KEY, granted ? 'granted' : 'denied'); } catch (e) {}
    /* Mirror the choice into a root-domain cookie so the app
       (app.swipeagain.com) and the UET/attribution code can read it --
       localStorage is per-origin and stops at the site. */
    try {
      document.cookie = 'sa_consent=' + (granted ? 'granted' : 'denied') +
        '; domain=.swipeagain.com; path=/; max-age=15552000; SameSite=Lax';
    } catch (e) {}
  }
  var choice = null;
  try { choice = localStorage.getItem(KEY); } catch (e) {}
  if (choice === 'granted' || choice === 'denied') {
    /* Returning visitor: re-assert their stored choice for this pageview. */
    setConsent(choice === 'granted');
    return;
  }
  var el = document.createElement('div');
  el.className = 'sa-consent';
  el.setAttribute('role', 'dialog');
  el.setAttribute('aria-label', 'Cookie consent');
  el.innerHTML =
    '<p>We use cookies for analytics and to keep the site running. Read our ' +
    '<a href="/pages/privacy-policy">privacy policy</a>.</p>' +
    '<div class="sa-consent-row">' +
    '<button type="button" class="sa-btn" data-sa-accept>Accept</button>' +
    '<button type="button" class="sa-btn sa-btn--ghost" data-sa-decline>Decline</button>' +
    '</div>';
  document.body.appendChild(el);
  requestAnimationFrame(function () { el.classList.add('show'); });
  el.querySelector('[data-sa-accept]').addEventListener('click', function () { setConsent(true); el.remove(); });
  el.querySelector('[data-sa-decline]').addEventListener('click', function () { setConsent(false); el.remove(); });
})();
